
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 8a8 8 0 018-8h24a8 8 0 018 8v24a8 8 0 01-8 8H8a8 8 0 01-8-8V8z","fill":"#FFE4D6"}}),_c('path',{attrs:{"d":"M24.543 16.028c-.023 1.503-.523 3.538-2.867 4.327.734-1.746.846-3.417.326-4.979-.695-2.097-3.014-3.735-4.557-4.627-.527-.306-1.203.074-1.193.683.02 1.112-.318 2.737-1.959 4.378C12.107 17.994 11 20.251 11 22.517 11 25.362 13 29 17 29c-4.041-4.04-1-7.483-1-7.483.846 5.914 4.988 7.483 7 7.483 1.711 0 5-1.25 5-6.448 0-3.133-1.332-5.51-2.385-6.899-.347-.458-1.064-.198-1.072.375z","fill":"#FF3232"}})])
          )
        }
      }
    